import { Button, Input, InputType, InputOptionBox } from '../../../../core/components/Index';
import { observer } from 'mobx-react';
import ApplyViewModel from './ApplyViewModel';
import { useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Steps } from './ApplyModels';
import { Appl } from '../../../../core/Appl';

const DirectDepositMemberDeclaration = observer(() => {
  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  let { memberId } = useParams();

  useAsyncEffect(async () => {
    await vm.loadStepAsync(Steps.DirectDepositMemberDeclaration, memberId!);
  }, []);

  return (
    <div className="space-y-8 max-w-4xl">
      <div>
        <h1 className="text-32px tracking--1percent text-neutral-800 font-semibold mb-4">Direct Deposit Authorization</h1>
        <p className="text-black text-15px tracking--1percent leading-26px">
          To ensure that your retirement benefits are deposited directly into your bank account, please provide your direct deposit information below.
        </p>
      </div>

      <div>
        <h2 className="text-gray-700 font-medium text-22px mb-4">
          Direct Deposit Account Information Summary
        </h2>
        <div className="space-y-2 text-black text-15px leading-6">
          <p className="font-semibold">
            <span className="font-normal">Institution Name:</span>{' '}
            {vm.model.directDeposit.institutionName || 'Not Specified'}
          </p>
          <p className="font-semibold">
            <span className="font-normal">Name of Account Holder:</span>{' '}
            {vm.model.directDeposit.accountHolderName || 'Not Specified'}
          </p>
          <p className="font-semibold">
            <span className="font-normal">Type of Depositor Account:</span>{' '}
            {vm.model.typeOfDepositListItems?.find(o => o.key === vm.model.directDeposit.lovAccountTypeId)?.value}
          </p>
          <p className="font-semibold">
            <span className="font-normal">Nine-Digit Routing Number:</span>{' '}
            {vm.model.directDeposit.bankRoutingNumeric || 'Not Specified'}
          </p>
          <p className="font-semibold">
            <span className="font-normal">Account Number:</span>{' '}
            {vm.model.directDeposit.bankAccountNumeric || 'Not Specified'}
          </p>
        </div>
      </div>
      <div>
        <h2 className="text-15px tracking--1percent text-black font-semibold mb-4">
          Member Acknowledgment
        </h2>
        <div className="flex items-start space-x-2">
          <InputOptionBox
            inputId="directDepositConsent"
            label=" I authorize SCERS to send 100% of my net pay to the financial
            institution and account designated above. This authority is to
            remain in full force and effect until SCERS has received written
            notification from me of its termination and is afforded a reasonable
            opportunity to act on it. I acknowledge that SCERS may debit my account 
            with amounts transferred after my date of death or transmitted in error."
            value={vm.model.directDeposit.directDepositConsent}
            checked={vm.model.directDeposit.directDepositConsent}
            onChange={(e: any) =>
              vm.onInputChange(e, 'directDepositConsent', vm.model.directDeposit)
            }
          />
        </div>
        {/* <div className='p-8'>
          I acknowledge that SCERS may debit my account with amounts transferred after my date of death or transmitted in error.
        </div> */}
      </div>

      {/* Buttons */}
      <div className="flex space-x-4 mt-6">
        <Button
          onClick={async () => await vm.onDirectDepositMemberDeclarationStepCompletedAsync()}
          title={`${vm.navigatedFromReviewScreen ? 'Save & Return to Review' : 'Save & Continue'}`}
          rounded
          disabled={!vm.model.directDeposit.directDepositConsent}
        />
        <Button
          label="Make a Change" outlined rounded severity="warning" onClick={() => vm.navigate(`direct-deposit/${Steps.DirectDepositAuthorization}`)}
        />
      </div>
    </div>
  );
});

export default DirectDepositMemberDeclaration;
